export class FieldDescriptor {
}

FieldDescriptor.TYPE_DOUBLE = 1;  // double, exactly eight bytes on the wire.
FieldDescriptor.TYPE_FLOAT = 2;  // float, exactly four bytes on the wire.
FieldDescriptor.TYPE_INT64 = 3;  // int64, varint on the wire.  Negative numbers
FieldDescriptor.TYPE_UINT64 = 4;  // uint64, varint on the wire.
FieldDescriptor.TYPE_INT32 = 5;  // int32, varint on the wire.  Negative numbers
FieldDescriptor.TYPE_FIXED64 = 6;  // uint64, exactly eight bytes on the wire.
FieldDescriptor.TYPE_FIXED32 = 7;  // uint32, exactly four bytes on the wire.
FieldDescriptor.TYPE_BOOL = 8;  // bool, varint on the wire.
FieldDescriptor.TYPE_STRING = 9;  // UTF-8 text.
FieldDescriptor.TYPE_GROUP = 10;  // Tag-delimited message.  Deprecated.
FieldDescriptor.TYPE_MESSAGE = 11;  // Length-delimited message.
FieldDescriptor.TYPE_BYTES = 12;  // Arbitrary byte array.
FieldDescriptor.TYPE_UINT32 = 13;  // uint32, varint on the wire
FieldDescriptor.TYPE_ENUM = 14;  // Enum, varint on the wire
FieldDescriptor.TYPE_SFIXED32 = 15;  // int32, exactly four bytes on the wire
FieldDescriptor.TYPE_SFIXED64 = 16;  // int64, exactly eight bytes on the wire
FieldDescriptor.TYPE_SINT32 = 17;  // int32, ZigZag-encoded varint on the wire
FieldDescriptor.TYPE_SINT64 = 18;  // int64, ZigZag-encoded varint on the wire
FieldDescriptor.MAX_TYPE = 18;  // Constant useful for defining lookup tables
